'use strict';

var buildSimpleValidator = require('./helpers/build-simple-validator');

/**
 *
 * @param {Object} value should consist of three keys: code, isOther, and value
 * @param {Object} validationOptions
 * @param {Array} validationOptions._selectOptions
 ** Example non-other value:
      {
        code: 'FEMALE',
        isOther: false,
      }
 ** Example other value:
      {
        value: 'She/They/Theirs',
        "isOther": true,
      }
 ** Example validation option:
      {
        "code": "FEMALE",
        "isOther": false,
        "label": 'She/Her/Hers
      },
 * @returns {Boolean}
 */

module.exports = buildSimpleValidator(function (value, validationOptions) {
  var code = value.code,
      inputValue = value.value,
      isOther = value.isOther;


  if (isOther) {
    return !code && !!inputValue;
  }

  if (inputValue) {
    return false;
  }

  var validCodes = validationOptions._selectOptions.map(function (opt) {
    return opt.code;
  });

  return validCodes.includes(code) && isOther === false;
}, 'You must choose a listed option or enter a different value', ['_selectOptions']);